import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'default' | 'ghost' | 'dark';
  size?: 'sm' | 'md';
}

export function IconButton({
  children,
  variant = 'default',
  size = 'md',
  className,
  ...props
}: IconButtonProps) {
  return (
    <button
      type="button"
      className={cn(
        'icon-btn',
        size === 'sm' && 'icon-btn-sm',
        variant === 'ghost' && 'icon-btn-ghost',
        variant === 'dark' && 'icon-btn-dark',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
